export const RECEIVE_QUERY_PARAMS = 'RECEIVE_QUERY_PARAMS';

export const REQUEST_TOPIC_DATA = 'REQUEST_TOPIC_DATA';
export const RECEIVE_TOPIC_DATA_RESPONSE = 'RECEIVE_TOPIC_DATA_RESPONSE';
export const RECEIVE_TOPIC_DATA_ERROR = 'RECEIVE_TOPIC_DATA_ERROR';
export const REQUEST_COMMUNITY_ONLINE_USER_COUNT = 'REQUEST_COMMUNITY_ONLINE_USER_COUNT';
export const RECEIVE_COMMUNITY_ONLINE_USER_COUNT_ERROR = 'RECEIVE_COMMUNITY_ONLINE_USER_COUNT_ERROR';
export const RECEIVE_COMMUNITY_ONLINE_USER_COUNT_RESPONSE = 'RECEIVE_COMMUNITY_ONLINE_USER_COUNT_RESPONSE';
export const INVALID_CONTENT_REQUEST = 'INVALID_CONTENT_REQUEST';

export const REQUEST_TOPIC_TREE = 'REQUEST_TOPIC_TREE';
export const RECEIVE_TOPIC_TREE_RESPONSE = 'RECEIVE_TOPIC_TREE_RESPONSE';
export const RECEIVE_TOPIC_TREE_ERROR = 'RECEIVE_TOPIC_TREE_ERROR';

export const REQUEST_QUICK_ANSWERS_TOPIC_TREE = 'REQUEST_HOME_TOPIC_TREE';
export const RESPONSE_QUICK_ANSWERS_TOPIC_TREE = 'RESPONSE_HOME_TOPIC_TREE';
export const ERROR_QUICK_ANSWERS_TOPIC_TREE = 'ERROR_HOME_TOPIC_TREE';

export const RECEIVE_FAQID = 'RECEIVE_FAQID';
export const NO_FAQID = 'NO_FAQID';

export const SELECT_TOPIC_L1 = 'SELECT_TOPIC_L1';
export const SELECT_TOPIC_L1_RESET = 'SELECT_TOPIC_L1_RESET';
export const SELECT_TOPIC_L2 = 'SELECT_TOPIC_L2';
export const SELECT_TOPIC_L2_RESET = 'SELECT_TOPIC_L2_RESET';
export const SELECT_TOPIC_L3 = 'SELECT_TOPIC_L3';
export const SELECT_RESULT = 'SELECT_RESULT';
export const SELECT_TOPIC_RESET = 'SELECT_TOPIC_RESET';
export const SELECT_TOPIC = 'SELECT_TOPIC';
export const DELETE_PERSIST_TOPICS = 'DELETE_PERSIST_TOPICS';

export const REQUEST_CALLUS = 'REQUEST_CALLUS';
export const RECEIVE_CALLUS_RESPONSE = 'RECEIVE_PHONE_NUMBER_RESPONSE';
export const RECEIVE_CALLUS_ERROR = 'RECEIVE_PHONE_NUMBER_ERROR';
export const BACK_TO_CONTACT_HOME = 'BACK_TO_CONTACT_HOME';
export const LOGOUT_TO_LOGIN = 'LOGOUT_TO_LOGIN';

export const REQUEST_ARTICLE = 'REQUEST_ARTICLE';
export const RECEIVE_ARTICLE_RESPONSE = 'RECEIVE_ARTICLE_RESPONSE';
export const RECEIVE_ARTICLE_ERROR = 'RECEIVE_ARTICLE_ERROR';

export const REQUEST_RELATED_ARTICLE = 'REQUEST_RELATED_ARTICLE';
export const RECEIVE_RELATED_ARTICLE_RESPONSE = 'RECEIVE_RELATED_ARTICLE_RESPONSE';
export const RECEIVE_RELATED_ARTICLE_ERROR = 'RECEIVE_RELATED_ARTICLE_ERROR';

export const REQUEST_RELATED_TOPIC = 'REQUEST_RELATED_TOPIC';
export const RECEIVE_RELATED_TOPIC_RESPONSE = 'RECEIVE_RELATED_TOPIC_RESPONSE';
export const RECEIVE_RELATED_TOPIC_ERROR = 'RECEIVE_RELATED_TOPIC_ERROR';

export const REQUEST_SUGGESTIONS = 'REQUEST_SUGGESTIONS';
export const RESET_SUGGESTIONS = 'RESET_SUGGESTIONS';
export const SHOW_SUGGESTIONS = 'SHOW_SUGGESTIONS';
export const RECEIVE_SUGGESTIONS = 'RECEIVE_SUGGESTIONS';
export const RECEIVE_SUGGESTIONS_ERROR = 'RECEIVE_SUGGESTIONS_ERROR';
export const UPDATE_SUGGESTIONS_FROM_CACHE = 'UPDATE_SUGGESTIONS_FROM_CACHE';

export const LOAD_MODAL_CONTAINER = 'LOAD_MODAL_CONTAINER';
export const CLOSE_MODAL_CONTAINER = 'CLOSE_MODAL_CONTAINER';
export const LOAD_MESSAGE_MODAL = 'LOAD_MESSAGE_MODAL';

export const LOGIN_CALLUS = 'LOGIN_CALLUS';
export const LOGIN_EMAIL = 'LOGIN_EMAILUS';
export const LOGIN_EMAIL_NO_INTENT = 'LOGIN_EMAIL_NO_INTENT';
export const LOGIN_SIGNIN_REDIRECT = 'LOGIN_SIGNIN_REDIRECT';
export const LOGIN_CHAT_BOT = 'LOGIN_CHAT_BOT';
export const LOGIN_CHAT = 'LOGIN_CHAT';

export const LOGIN_MESSAGE_US = 'LOGIN_MESSAGE_US';

export const REQUEST_BY_EMAIL = 'REQUEST_BY_EMAIL';
export const RECEIVE_EMPTY_FIELDS = 'RECEIVE_EMPTY_FORM_FIELDS';
export const RECEIVE_FORM_FIELDS = 'RECEIVE_FORM_FIELDS_RESPONSE';

export const PRESERVE_FIELD_DATA = 'PRESERVE_FIELD_DATA';
export const CHANGE_TOPIC = 'CHANGE_TOPIC_TREE';
export const SEND_EMAIL = 'SEND_EMAIL_REQUEST';
export const RECEIVE_EMAIL_RESPONSE = 'RECEIVE_EMAIL_SENT_RESPONSE';
export const RECEIVE_EMAIL_ERROR = 'RECEIVE_EMAIL_ERROR';
export const CANCEL_EMAIL_FORM = 'CANCEL_EMAIL_FORM';

export const REQUEST_HELPCENTER_ALERTS = 'REQUEST_HELPCENTER_ALERTS';
export const RECEIVE_HELPCENTER_ALERTS = 'RECEIVE_HELPCENTER_ALERTS';
export const RECEIVE_HELPCENTER_ALERTS_ERROR = 'RECEIVE_HELPCENTER_ALERTS_ERROR';

export const LOCALE_CHANGED = 'LOCALE_CHANGED';
export const LOGOUT = 'LOGOUT';
export const LOGIN = 'LOGIN';

export const PRESERVE_FILTER_FIELD_DATA = 'PRESERVE_FILTER_FIELD_DATA';
export const REQUEST_ARTICLE_SEARCH = 'REQUEST_ARTICLE_SEARCH';
export const RECEIVE_ARTICLE_SEARCH_RESPONSE = 'RECEIVE_ARTICLE_SEARCH_RESPONSE';
export const RECEIVE_ARTICLE_SEARCH_ERROR = 'RECEIVE_ARTICLE_SEARCH_ERROR';

export const OPEN_MOBILE_FILTER = 'OPEN_MOBILE_FILTER';
export const CLOSE_MOBILE_FILTER = 'CLOSE_MOBILE_FILTER';

export const SWITCH_CONTENT_TOGGLE = 'SWITCH_CONTENT_TOGGLE';
export const RESET_RELATED_ARTICLE = 'RESET_RELATED_ARTICLE';

export const CONTACT_LOCATION_CHANGE = 'CONTACT_LOCATION_CHANGE';
export const CONTACT_LOCATION_LOAD = 'CONTACT_LOCATION_LOAD';

export const REQUEST_WEB_TREE_TOPICS = 'REQUEST_WEB_TREE_TOPICS';
export const RECEIVE_WEB_TREE_TOPICS = 'RECEIVE_WEB_TREE_TOPICS';
export const RECEIVE_WEB_TREE_TOPICS_ERROR = 'RECEIVE_WEB_TREE_TOPICS_ERROR';
export const SELECT_QUICK_TOPIC = 'SELECT_QUICK_TOPIC';

export const REQUEST_PPC_ENABLE = 'REQUEST_PPC_ENABLE';
export const RECEIVE_PPC_ENABLE = 'RECEIVE_PPC_ENABLE';
export const RECEIVE_PPC_ENABLE_ERROR = 'RECEIVE_PPC_ENABLE_ERROR';

export const EMAIL_INTENT_SELECTED_NO_INTENT = 'EMAIL_INTENT_SELECTED_NO_INTENT';
export const RECEIVE_FORM_FIELDS_NO_INTENT = 'RECEIVE_FORM_FIELDS_NO_INTENT';
export const RECEIVE_EMPTY_FIELDS_NO_INTENT = 'RECEIVE_EMPTY_FIELDS_NO_INTENT';
export const PRESERVE_FIELD_DATA_NO_INTENT = 'PRESERVE_FIELD_DATA_NO_INTENT';
export const SEND_EMAIL_NO_INTENT = 'SEND_EMAIL_NO_INTENT';
export const RECEIVE_EMAIL_RESPONSE_NO_INTENT = 'RECEIVE_EMAIL_RESPONSE_NO_INTENT';
export const RECEIVE_EMAIL_ERROR_NO_INTENT = 'RECEIVE_EMAIL_ERROR_NO_INTENT';
export const CANCEL_EMAIL_FORM_NO_INTENT = 'CANCEL_EMAIL_FORM_NO_INTENT';
export const REQUEST_BY_EMAIL_NO_INTENT = 'REQUEST_BY_EMAIL_NO_INTENT';
export const ERROR_TOPIC_TREE = 'ERROR_TOPIC_TREE';
export const RECEIVE_CONTACT_CHANNELS_NO_DATA = 'RECEIVE_CONTACT_CHANNELS_NO_DATA';

// IDI Contact options request received data from IDI post API
export const REQUEST_IDI_CONTACT_OPTIONS = 'REQUEST_IDI_CONTACT_OPTIONS';
export const RECEIVED_RESPONSE_FROM_RISK = 'RECEIVED_RESPONSE_FROM_RISK';
export const REQUEST_RESPONSE_FROM_RISK = 'REQUEST_RESPONSE_FROM_RISK';
export const RECEIVE_IDI_CONTACT_OPTIONS_RESPONSE = 'RECEIVE_IDI_CONTACT_OPTIONS_RESPONSE';
export const RECEIVE_IDI_CONTACT_OPTIONS_ERROR = 'RECEIVE_IDI_CONTACT_OPTIONS_ERROR';

// Search Topic Tree to crawl intent topic
export const GET_SEARCH_OBJECT = 'GET_SEARCH_OBJECT';
export const UPDATE_INTENT_QUERY = 'UPDATE_INTENT_QUERY';
export const GET_INTENT_SUGGESTION = 'GET_INTENT_SUGGESTION';
export const CLEAR_INTENT_SUGGESTION = 'CLEAR_INTENT_SUGGESTION';
export const CLEAR_ALL_INTENT = 'CLEAR_ALL_INTENT';
export const EMPTY_INTENT_SUGGESTION = 'EMPTY_INTENT_SUGGESTION';
export const CRAWLING_SEARCH_TOPIC = 'CRAWLING_SEARCH_TOPIC';
export const HIDE_INTENT_SUGGESTION = 'HIDE_INTENT_SUGGESTION';
export const AUTO_SUGGESTION_FIRED = 'AUTO_SUGGESTION_FIRED';
export const FULL_SEARCH_FIRED = 'FULL_SEARCH_FIRED';
export const CLEAR_QULATRICS_INTERCEPTS = 'CLEAR_QULATRICS_INTERCEPTS';
export const ACCESS_LOGOUT_EMAIL = 'ACCESS_LOGOUT_EMAIL';
export const UPDATE_LOGOUT_EMAIL_TOPIC = 'UPDATE_LOGOUT_EMAIL_TOPIC';

// Chat Bot session Checker
export const REQUEST_CHAT_BOT_SESSION = 'REQUEST_CHAT_BOT_SESSION';
export const RECEIVE_CHAT_BOT_SESSION_RESULT = 'RECEIVE_CHAT_BOT_SESSION_RESULT';
export const CATCH_CHAT_BOT_SESSION_ERROR = 'CATCH_CHAT_BOT_SESSION_ERROR';
export const CHATBOT_CLICKED = 'CHATBOT_CLICKED';
export const CHATBOT_CLICKED_FALSE = 'CHATBOT_CLICKED_FALSE';
export const UPDATE_FINAL_CONTACT_OPTIONS = 'UPDATE_FINAL_CONTACT_OPTIONS';

// Chat Inigible Modal after log in
export const LOAD_CHAT_INELIGIBLE_MODAL_CONTAINER = 'LOAD_CHAT_INELIGIBLE_MODAL_CONTAINER';
export const CLOSE_CHAT_INELIGIBLE_MODAL_CONTAINER = 'CLOSE_CHAT_INELIGIBLE_MODAL_CONTAINER';

// SpeechRecognition actions
export const SPEECH_START_RECORDING = 'SPEECH_START_RECORDING';
export const SPEECH_END_RECORDING = 'SPEECH_END_RECORDING';
export const SPEECH_RECOGNITION_REQUEST = 'SPEECH_RECOGNITION_REQUEST';
export const RESET_SPEECH_QUERY = 'RESET_SPEECH_QUERY';
export const ERROR_SPEECH_RECORDING = 'ERROR_SPEECH_RECORDING';
export const SOUND_START_RECORDING = 'SOUND_START_RECORDING';
export const SOUND_END_RECORDING = 'SOUND_END_RECORDING';

// LEXA async message Eligibility checker
export const RESET_LEXA_MESSAGE = 'RESET_LEXA_MESSAGE';
export const UPDATE_LEXA_MESSAGE = 'UPDATE_LEXA_MESSAGE';

// Mobile Web call - IVR Authentication webpin
export const REQUEST_WEB_IVR_AUTHENTICATION = 'REQUEST_WEB_IVR_AUTHENTICATION';
export const RECEIVE_WEB_IVR_AUTHENTICATION = 'RECEIVE_WEB_IVR_AUTHENTICATION';
export const RECEIVE_WEB_IVR_AUTHENTICATION_ERROR = 'RECEIVE_WEB_IVR_AUTHENTICATION_ERROR';

// POST ChatBot Eligibility Response
export const POST_CHATBOT_ELIGIBILITY_RESPONSE = 'POST_CHATBOT_ELIGIBILITY_RESPONSE';
export const POST_CHATBOT_ELIGIBILITY_ERROR = 'POST_CHATBOT_ELIGIBILITY_ERROR';
export const REQUEST_POST_CHATBOT_ELIGIBILITY = 'REQUEST_POST_CHATBOT_ELIGIBILITY';
export const POST_CHATBOT_ELIGIBILITY_FALSE = 'POST_CHATBOT_ELIGIBILITY_FALSE';
export const MMT_CHECK_RESPONSE = 'MMT_CHECK_RESPONSE';

// Step-up
// Risk
export const REQUEST_RISK_CHECK_INITIATED = 'REQUEST_RISK_CHECK_INITIATED';
export const RECEIVE_RISK_ERROR = 'RECEIVE_RISK_ERROR';
export const RECEIVE_RISK_CHECK = 'RECEIVE_RISK_CHECK';
export const LOAD_STEP_UP_CONTAINER = 'LOAD_STEP_UP_CONTAINER';
export const CLOSE_STEP_UP_CONTAINER = 'CLOSE_STEP_UP_CONTAINER';
export const RESET_STEP_UP = 'RESET_STEP_UP';
export const RECEIVED_RISK_ALLOW = 'RECEIVED_RISK_ALLOW';
export const PERFORM_STEP_UP = 'PERFORM_STEP_UP';
export const STEP_UP_REQUEST_TIME = 'STEP_UP_REQUEST_TIME';

// ANW
export const REQUEST_ANW_CHECK_INITIATED = 'REQUEST_ANW_CHECK_INITIATED';
export const RECEIVE_ANW_SUCCESS = 'RECEIVE_ANW_SUCCESS';
export const RECEIVE_ANW_ERROR = 'RECEIVE_ANW_ERROR';

// PayPal Me hardcode Email fields
export const PROVIDE_PPM_EMAIL_FIELDS = 'PROVIDE_PPM_EMAIL_FIELDS';

export const STORE_CHATBOT_QUERY_PARAMS = 'STORE_CHATBOT_QUERY_PARAMS';

// COVID-19 BCP
export const SHOW_HIDE_COVID_BCP_ALERT = 'SHOW_HIDE_COVID_BCP_ALERT';
export const SET_IS_LOGGED_OUT_CHAT_ENABLED = 'SET_IS_LOGGED_OUT_CHAT_ENABLED';
export const SET_IS_PUI_TOPIC_SUPPORTED_ENABLED = 'SET_IS_PUI_TOPIC_SUPPORTED_ENABLED';

// callus from complaintspage
export const CALLUS_FROM_COMPLAINTS_PAGE = 'CALLUS_FROM_COMPLAINTS_PAGE';
export const RESET_CALLUS_FROM_COMPLAINTS_PAGE = 'RESET_CALLUS_FROM_COMPLAINTS_PAGE';

// omnichannel
export const RESET_OMNI_CHANNEL_PROMPT_INFO = 'RESET_OMNI_CHANNEL_PROMPT_INFO';

export const FROM_EMAIL_PAGE = 'FROM_EMAIL_PAGE';

export const DISPLAY_LOGOUT_WEB_FORM = 'DISPLAY_LOGOUT_WEB_FORM';

export const SET_CONTEXT_INTENTS = 'SET_CONTEXT_INTENTS';
export const SET_CONTEXT_RESPONSE = 'SET_CONTEXT_RESPONSE';
export const RESET_OCP_CONTACT_RESPONSE = 'RESET_OCP_CONTACT_RESPONSE';

export const DISPLAY_VHT_WIDGET = 'DISPLAY_VHT_WIDGET';
export const HIDE_VHT_WIDGET = 'HIDE_VHT_WIDGET';
